// Session management utility

export const session = {
  // Get current user
  getUser: () => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error("Error parsing user data:", error);
      return null;
    }
  },

  // Get auth token
  getToken: () => {
    return localStorage.getItem("authToken");
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem("authToken");
    const user = localStorage.getItem("user");
    return !!(token && user);
  },

  // Clear session
  clear: () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  },

  // Update user data
  updateUser: (userData) => {
    try {
      localStorage.setItem("user", JSON.stringify(userData));
    } catch (error) {
      console.error("Error updating user data:", error);
    }
  },

  // Set session data
  setSession: (token, userData) => {
    try {
      localStorage.setItem("authToken", token);
      localStorage.setItem("user", JSON.stringify(userData));
    } catch (error) {
      console.error("Error setting session data:", error);
    }
  },

  // Check token expiration
  isTokenExpired: (token) => {
    try {
      if (!token) return true;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp * 1000 < Date.now();
    } catch (error) {
      console.error("Error checking token expiration:", error);
      return true;
    }
  },

  // Refresh session if needed
  refreshIfNeeded: async () => {
    const token = localStorage.getItem("authToken");
    if (token && session.isTokenExpired(token)) {
      try {
        // Clear current session
        session.clear();
        // Redirect to login
        window.location.href = "/login";
      } catch (error) {
        console.error("Error refreshing session:", error);
        session.clear();
        window.location.href = "/login";
      }
    }
  },
};
